import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  visible: false,
}

const slice = createSlice({
  initialState,
  name: "loader",
  reducers: {
    toggle: state => {
      state.visible = !state.visible
    },
    show: state => {
      state.visible = true
    },
    hide: state => {
      state.visible = false
    },
  },
});

export const {
  toggle, show, hide,
} = slice.actions;

export default slice.reducer;